import { useTranslation } from "react-i18next";
import { Company, JobAd } from "../lib/models";
import JobAdCard from "./JobAdCard";
import FormText from "./forms/FormText";
import { cn } from "./helpers";

const JobAdsList: React.FC<{ jobAds: JobAd[]; company: Company }> = ({
  jobAds,
  company,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {jobAds.length > 0 ? (
        <ul
          className={cn(
            "inline-grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-2 mx-auto",
            {
              "md:grid-cols-[580px]": jobAds.length === 1,
            }
          )}
        >
          {jobAds.map((ad) => (
            <JobAdCard key={ad.jobAdId} jobAd={ad} company={company} />
          ))}
        </ul>
      ) : (
        <div className="w-full mt-10 mb-10">
          <FormText text={t("AdView:noActiveAds")} />
        </div>
      )}
    </>
  );
};

export default JobAdsList;
